export default __webpack_public_path__ + "static/media/setting.0dfe479c.svg";